import { tw } from 'utils/classnames'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

interface ImageBannerProps {
  className?: string
}

export function ImageBanner({ className }: ImageBannerProps) {
  const t = useTranslations('pages.3d-svg.cards')

  return (
    <div className={tw('rounded-2 relative mb-4 h-[278px] w-full overflow-hidden z-0', className)}>
      <Image
        src="https://www.creativefabrica.com/wp-content/themes/creativefabricanew/v2.0/images/CF_3D-PaperCrafting_SEO_Image2-Banner_01.jpg"
        alt="3D SVG Crafts"
        width="380"
        height="278"
        className={tw('absolute bottom-0 z-0 h-full w-full object-cover')}
        unoptimized
      />
      <div className=" text-cf-white absolute z-10 flex h-full flex-col justify-end px-10 py-5 font-bold uppercase">
        {t('info')}
      </div>
    </div>
  )
}
